import { type GridCssResponsiveVariables } from '../grid';
import { type RatiosCssResponsiveVariables } from '../ratios';
import {
    type EasingCssResponsiveVariables,
    type PacingCssResponsiveVariables,
    type TransitionsCssResponsiveVariables,
} from '../transitions';
import { type CssResponsiveVariables, type CssVariables } from '../types';
import { type ZIndexCssResponsiveVariables } from '../z-index';
import lightTheme from './light';
import orangeTheme from './orange';
import darkTheme from './dark';

export interface Theme {
    statics: CssVariables<any>;
    responsives: CssResponsiveVariables<
        GridCssResponsiveVariables &
            RatiosCssResponsiveVariables &
            PacingCssResponsiveVariables &
            EasingCssResponsiveVariables &
            TransitionsCssResponsiveVariables &
            ZIndexCssResponsiveVariables &
            Partial<CssVariables<any>>
    >;
}
export interface Themes {
    light: Theme;
    orange: Theme;
    dark: Theme;
}

export type ThemeName = keyof Themes;

export const themes: Themes = {
    light: lightTheme,
    orange: orangeTheme,
    dark: darkTheme,
};
export const validThemes = Object.keys(themes);

// @TODO Make it work with responsives as well or scrap?
// export const activateTheme = (themeName: string): void => {
//     if (validThemes.indexOf(themeName) === -1) {
//         return;
//     }
//     const theme = themes[themeName];
//     const root = document.documentElement;
//     Object.keys(theme).forEach(key => {
//         const value = theme[key];
//         root.style.setProperty(key, value);
//     });
// };

// @TODO Doesn't work?
// export const getCssVariableValue = (cssVariableName: string) => {
//     const root = document.documentElement;
//     return root.style.getPropertyValue(cssVariableName);
// };

export default themes;
